import { get } from '@/Utils/axios'
import { fileDownload } from '../NutritionAnalyse/api'
// 公司列表查询
export const factoryGet = () => get('/fast-data-analysis/factory/FactoryList')
// 工厂配方原料数据列表获取
export const materialsGet = data => get('/fast-data-analysis/productrawanalysis/list', data)
// 没有原料使用的接口
export const materialsGet2 = data => get('/fast-data-analysis/productrawanalysis/productList', data)

export const materialsDownload = data => get('/fast-data-analysis/formularaw/asyncFactoryFormulaRawMaterialExport', data)

export const exportFile = data => fileDownload('/fast-data-analysis/formularaw/asyncFactoryFormulaRawMaterialExport', data)
